import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import Container from '~shared/Container'
import Topic from '~shared/Topic'
import SliderNav from '~shared/SliderNav'
import Stops from '~shared/Stops'

const Content = styled.div`
    ${Topic.Title} {
        margin: 0;
        text-align: left;
        margin-bottom: 1.25rem;
    }

    ${Topic.Paragraph} + ${Button} {
        margin-top: 2rem;
    }

    @media (min-width: ${TABLET}px) {
        ${Topic.Title} {
            white-space: nowrap;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${Topic.Paragraph} + ${Button} {
            margin-top: 2.5rem;
        }
    }
`

const Icon = styled.div``

const Inner = styled.div`
    display: flex;
    flex-direction: column-reverse;

    ${Icon} {
        height: 200px;
        position: relative;

        > * {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    @media (min-width: ${TABLET}px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        ${Content} {
            max-width: 360px;
        }

        ${Icon} {
            > * {
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }

            position: absolute;
            top: 0;
            bottom: 0;
            right: 80px;
            width: 120px;
            height: auto;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${Content} {
            max-width: 486px;
        }

        ${Icon} {
            right: 140px;
            width: 232px;
        }
    }
`

const PaddedBox = styled.div`
    position: relative;
    background-color: #FAFAFA;
    border-radius: 8px;
    padding: 1.5rem 1.5rem 4rem 1.5rem;

    @media (min-width: ${TABLET}px) {
        padding: 4.5rem 2rem 3.25rem;
    }

    ${SliderNav} {
        margin-top: 2rem;
    }

    @media (min-width: 1024px) {
        padding: 5rem 6rem 3.75rem;
    }
`

const Slides = styled.div`
    display: grid;
    align-items: start;

    > * {
        grid-row: 1;
        grid-column: 1;
        opacity: 0;
        transition: 300ms ease-in-out opacity;
    }
`

const UnstyledRoundedBox = forwardRef(({ children, onClick, noSelect, ...props }, ref) => (
    <div {...props} ref={ref}>
        <Container onClick={onClick}>
            <PaddedBox>
                {children}
            </PaddedBox>
        </Container>
    </div>
))

const RoundedBox = styled(UnstyledRoundedBox)`
    ${({ noSelect }) => !!noSelect && css`
        user-select: none;
    `}

    @media (min-width: ${TABLET}px) {
        ${Container} {
            max-width: 912px;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${Container} {
            max-width: 1160px;
        }
    }
`

const Gallery = ({ items = [] }) => (
    <Stops current={0}>
        {({ current, setStop }) => (
            <RoundedBox onClick={() => setStop((current + 1) % items.length)} noSelect $appear>
                <Slides>
                    {items.map((Slide, index) => (
                        <Slide
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            style={{
                                opacity: Number(current === index),
                            }}
                        />
                    ))}
                </Slides>
                <SliderNav size={items.length} current={current} onChange={setStop} />
            </RoundedBox>
        )}
    </Stops>
)

export default Object.assign(RoundedBox, {
    Inner,
    Content,
    Icon,
    Gallery,
    Slides,
})
